import React, { useEffect } from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from './index'
import Loading from "../views/components/Loading";
import { useSelector } from "react-redux";
import '../assets/css/font.css'
import '../assets/css/style.css'
// import '../assets/css/media.css'; 테블릿


const DefaultLayout = (props) => {

   useEffect(() => {
      // 운영서버 배포 빌드 날짜값과 로컬스토리지의 날짜값을 비교하여 일치하지 않을 시 강제 새로고침
      if (process.env.NODE_ENV === 'production') {
         fetch("/meta.json")
            .then((response) => response.json())
            .then((meta) => {

               const latestVersionDate = Number(window.localStorage.getItem('buildDate'));
               const currentVersionDate = meta.buildDate;

               if (latestVersionDate != currentVersionDate) {
                  window.localStorage.setItem('buildDate', currentVersionDate);
                  window.location.reload(true);
               }
            });
      }
   }, [props.location]);

   return (
      <>
         {/* <AppSidebar /> */}
         <>
            <AppHeader />
            <>
               <AppContent  {...props} />
            </>
            <AppFooter />
         </>
      </>
   )

}

export default DefaultLayout
